export default "__VITE_ASSET__BubF7GD4__"